import { TGroup } from '../../components/Select/types'
import { ROLES_NAMES } from '../../constants'
import { useSelector } from 'react-redux'
import { getUser } from '../../redux/store/user/getters'
import { IPartialUserInfo } from '../../redux/store/user/types'
import { TSelectedUsers } from '../RFP/RFPDetails/ResponsibleForRFP/UserListLedCentral/types'

type Props = {
  users: IPartialUserInfo[]
  setFilteredOptions: (options: IPartialUserInfo[]) => void
}

export const useSelect = ({ users, setFilteredOptions }: Props) => {
  const currentUser = useSelector(getUser)

  const returnSelectUsers = (arr: TSelectedUsers): TGroup[] => {
    if (arr?.length) {
      return Object.values(
        arr.reduce(
          (p, n) => ({
            ...p,
            [n.role]: {
              label: ROLES_NAMES[n.role],
              options: [
                ...(p[n.role]?.options || []),
                {
                  value: n.uuid,
                  key: n.uuid,
                  label: (
                    <>
                      {n?.first_name} {n?.last_name}
                      <span className="assign-text">
                        {n?.uuid === currentUser.uuid && '(assign to me)'}
                      </span>
                    </>
                  )
                }
              ]
            }
          }),
          {}
        )
      )
    }
    return []
  }

  const handleSearch = (searchText) => {
    const filteredUsers: IPartialUserInfo[] = users?.filter((option) => {
      const fullName = `${option.first_name} ${option.last_name}`.toLowerCase()
      return fullName.includes(searchText.toLowerCase())
    })
    setFilteredOptions(filteredUsers || [])
  }

  return {
    returnSelectUsers,
    handleSearch
  }
}
